import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface AuditLogItem {
  id: string;
  tenant_id: string;
  actor_id: string | null;
  actor_role: string | null;
  action: string;
  resource_type: string;
  resource_id: string | null;
  request_id: string | null;
  occurred_at: string;
  metadata: Record<string, unknown>;
}

export interface AuditLogListResponse {
  items: AuditLogItem[];
  total: number;
}

export function useAuditLogs(params?: {
  action?: string;
  resource_type?: string;
  limit?: number;
  offset?: number;
}) {
  const qs = new URLSearchParams();
  if (params?.action) qs.set("action", params.action);
  if (params?.resource_type) qs.set("resource_type", params.resource_type);
  if (params?.limit) qs.set("limit", String(params.limit));
  if (params?.offset) qs.set("offset", String(params.offset));
  const suffix = qs.toString() ? `?${qs.toString()}` : "";

  return useQuery<AuditLogListResponse>({
    queryKey: ["audit-export-logs", params],
    queryFn: () => api.get<AuditLogListResponse>(`/api/audit-export/logs${suffix}`),
  });
}

export async function downloadAuditCsv(params?: {
  action?: string;
  resource_type?: string;
  limit?: number;
}): Promise<Blob> {
  const qs = new URLSearchParams();
  if (params?.action) qs.set("action", params.action);
  if (params?.resource_type) qs.set("resource_type", params.resource_type);
  if (params?.limit) qs.set("limit", String(params.limit ?? 2000));
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  const response = await api.raw.get<Blob>(`/api/audit-export/logs/export.csv${suffix}`, {
    responseType: "blob",
  });
  return response.data;
}
